import api from "@/services/api.service";
import { formatRegionUrl } from "@/utils/string-utils";
import { GetterTree } from "vuex";
import { RootState } from "../types";
import { RegionState } from "./types";

export const getters: GetterTree<RegionState, RootState> = {
	/**
	 * Gets the url for a specified region id.
	 * @param state The vuex state.
	 * @returns The url of the region.
	 */
	getRegionUrl: (state: RegionState) => (regionId: number) => {
		if (regionId == 0 || regionId == null) {
			return api.getOriginalApiUrl;
		}

		var region = state.regions[regionId];

		if (region.url) {
			return region.url;
		} else {
			return null;
		}
	},

	/**
	 * Gets the title for a specified region id.
	 * @param state The vuex state.
	 * @returns The title of the region.
	 */
	getRegionTitle: (state: RegionState) => (regionId: number) => {
		if (regionId == 0 || regionId == null) {
			return "Local";
		}

		var region = state.regions[regionId];

		if (region.title) {
			return region.title;
		} else {
			return null;
		}
	},

	/**
	 * Gets the region based on a specified region id.
	 * @param state The vuex state.
	 * @returns The region.
	 */
	getRegion: (state: RegionState) => (regionId: number) => {
		if (regionId == 0 || regionId == null) {
			return null;
		}

		if (state.regions[regionId]) {
			return state.regions[regionId];
		} else {
			return null;
		}
	},

	/**
	 * Gets the XSRF token for a specified region url.
	 * @param state The vuex state.
	 * @returns The url of the region.
	 */
	getXsrfToken: (state: RegionState) => (regionUrl: string) => {
		return state.xsrfTokens[regionUrl] || null;
	},

	/**
	 * Gets the list of regions with XSRF tokens.
	 * @param state The vuex state.
	 * @returns The list of regions that have XSRF tokens.
	 */
	getRegionsWithXsrfTokens: (state: RegionState) => Object.keys(state.xsrfTokens).map(formatRegionUrl),

	/**
	 * Gets a value indicating whether the user has any regions available to them.
	 * @param state The vuex state.
	 * @returns True if the user has other regions available, otherwise false.
	 */
	hasRegionsAvailable: (state: RegionState) => Object.keys(state.regions).length > 0,

	/**
	 * Gets the list of regions.
	 * @param state The vuex state.
	 * @returns List of regions.
	 */
	getAllRegions: (state: RegionState) => state.allRegions
};
